/* Tansy Active · banners da home (sections/tansy-banners.liquid).
   Passa sozinho a cada data-intervalo ms (0 = não passa), menos com "reduzir movimento".
   Para enquanto o cursor está em cima, o foco está dentro ou a aba está escondida; para de vez quando a
   pessoa arrasta, usa uma seta ou um ponto (ela tomou o controle). O botão de pausa liga e desliga.
   Só o banner visível fica ao alcance do Tab (os outros ficam "inert"). */
if (!customElements.get('tansy-banners')) {
  customElements.define(
    'tansy-banners',
    class TansyBanners extends HTMLElement {
      connectedCallback() {
        this.trilho = this.querySelector('[data-trilho]');
        this.slides = [...this.querySelectorAll('[data-slide]')];
        this.pontos = [...this.querySelectorAll('[data-ponto]')];
        this.pausa = this.querySelector('[data-pausa]');
        if (!this.trilho || this.slides.length === 0) return;

        this.atual = 0;
        this.reduzir = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.intervalo = Number(this.dataset.intervalo) || 0;
        this.passa = this.intervalo > 0 && !this.reduzir && this.slides.length > 1;
        this.parado = !this.passa; // parado pela pessoa (pausa, seta, ponto, arrasto)
        this.segura = new Set(); // motivos passageiros: cursor, foco, aba escondida
        this.relogio = null;

        this.aoRolar = this.aoRolar.bind(this);
        this.trilho.addEventListener('scroll', this.aoRolar, { passive: true });

        const assumir = () => this.assumir();
        this.trilho.addEventListener('pointerdown', assumir, { passive: true });
        this.trilho.addEventListener('touchstart', assumir, { passive: true });
        this.trilho.addEventListener('wheel', (e) => { if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) assumir(); }, { passive: true });

        this.querySelector('[data-anterior]')?.addEventListener('click', () => { this.assumir(); this.ir(this.atual - 1); });
        this.querySelector('[data-proximo]')?.addEventListener('click', () => { this.assumir(); this.ir(this.atual + 1); });
        this.pontos.forEach((p) => p.addEventListener('click', () => { this.assumir(); this.ir(Number(p.dataset.ponto)); }));

        if (this.pausa && this.passa) {
          this.pausa.hidden = false;
          this.pausa.addEventListener('click', () => {
            this.parado = !this.parado;
            this.marcarPausa();
            this.agendar();
          });
        }

        this.addEventListener('pointerenter', (e) => { if (e.pointerType === 'mouse') this.segurar('cursor', true); });
        this.addEventListener('pointerleave', (e) => { if (e.pointerType === 'mouse') this.segurar('cursor', false); });
        this.addEventListener('focusin', () => this.segurar('foco', true));
        this.addEventListener('focusout', (e) => { if (!this.contains(e.relatedTarget)) this.segurar('foco', false); });
        this.aoMudarAba = () => this.segurar('aba', document.hidden);
        document.addEventListener('visibilitychange', this.aoMudarAba);

        this.aoRedimensionar = () => { this.trilho.scrollLeft = this.atual * this.trilho.clientWidth; };
        window.addEventListener('resize', this.aoRedimensionar);

        // Janela do cupom (snippets/tansy-welcome-popup.liquid): enquanto ela ainda vai abrir ou está aberta, o banner
        // espera; o tempo começa a contar quando a cliente fecha a janela (Eric, 04/11/2026).
        if (window.tansyPopupPendente) {
          this.segura.add('janela');
          document.addEventListener('tansy:popup-fechado', () => this.segurar('janela', false), { once: true });
        }

        // Editor de tema: escolher um bloco mostra aquele banner e para.
        this.aoEscolherBloco = (e) => {
          const i = this.slides.findIndex((s) => s.contains(e.target) || s === e.target);
          if (i < 0) return;
          this.assumir();
          this.ir(i, true);
        };
        document.addEventListener('shopify:block:select', this.aoEscolherBloco);

        this.marcar();
        this.marcarPausa();
        this.agendar();
      }

      disconnectedCallback() {
        clearTimeout(this.relogio);
        document.removeEventListener('visibilitychange', this.aoMudarAba);
        document.removeEventListener('shopify:block:select', this.aoEscolherBloco);
        window.removeEventListener('resize', this.aoRedimensionar);
      }

      ir(i, seco = false) {
        const n = this.slides.length;
        const alvo = ((i % n) + n) % n;
        this.trilho.scrollTo({ left: alvo * this.trilho.clientWidth, behavior: seco || this.reduzir ? 'auto' : 'smooth' });
        this.atual = alvo;
        this.marcar();
      }

      aoRolar() {
        const largura = this.trilho.clientWidth || 1;
        const i = Math.round(this.trilho.scrollLeft / largura);
        if (i !== this.atual && i >= 0 && i < this.slides.length) {
          this.atual = i;
          this.marcar();
        }
      }

      marcar() {
        this.slides.forEach((s, i) => {
          const ativo = i === this.atual;
          if ('inert' in s) s.inert = !ativo;
          else s.setAttribute('aria-hidden', String(!ativo));
        });
        this.pontos.forEach((p, i) => {
          if (i === this.atual) p.setAttribute('aria-current', 'true');
          else p.removeAttribute('aria-current');
        });
      }

      assumir() {
        if (this.parado) return;
        this.parado = true;
        this.marcarPausa();
        this.agendar();
      }

      segurar(motivo, sim) {
        if (sim) this.segura.add(motivo);
        else this.segura.delete(motivo);
        this.agendar();
      }

      marcarPausa() {
        this.toggleAttribute('data-parado', this.parado);
        if (this.pausa) this.pausa.setAttribute('aria-label', this.parado ? 'Play banners' : 'Pause banners');
      }

      agendar() {
        clearTimeout(this.relogio);
        if (!this.passa || this.parado || this.segura.size > 0) return;
        this.relogio = setTimeout(() => {
          this.ir(this.atual + 1);
          this.agendar();
        }, this.intervalo);
      }
    }
  );
}
